import { render, staticRenderFns } from "./PowerRankingsList.vue?vue&type=template&id=88ebbee6&"
import script from "./PowerRankingsList.vue?vue&type=script&lang=js&"
export * from "./PowerRankingsList.vue?vue&type=script&lang=js&"
import style0 from "./PowerRankingsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports